import { PROD_ENVIRONMENT, LOCAL_ENVIRONMENT } from 'constants/index';
import { COUNTRY_CODE_DE } from 'commonsConstants/countryCodes';

const isNotProdEnvironment = __ENV__ !== PROD_ENVIRONMENT;
const isLocalEnv = __ENV__ === LOCAL_ENVIRONMENT;

const getPathByCountry = {
    [COUNTRY_CODE_DE]: 'kunde-werden/onboarding/registration',
};
const mainModelUrl = `https://onboarding.${isNotProdEnvironment && `${__ENV__}.`}mb.openbank.${__ORIGIN_COUNTRY__}`;
const modelOnboardingUrl = `${mainModelUrl}/${getPathByCountry[__ORIGIN_COUNTRY__]}`;

export const shouldRedirectToModelOnboarding = (withAccessToken, withContractToken) => {
    if (isLocalEnv) return false;
    return !withAccessToken && !withContractToken;
};

export const goModelOnboarding = () => {
    window.location.href = modelOnboardingUrl;
};
